import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";

const H2 = ({ children }) => <h2 className="text-lg font-semibold text-[#0b2545] mt-8 mb-2 border-l-4 border-[#14B8A6] pl-3">{children}</h2>;
const P = ({ children }) => <p className="text-sm leading-relaxed text-slate-600 mb-3">{children}</p>;
const LI = ({ children }) => <li className="text-sm leading-relaxed text-slate-600 mb-1.5 ml-4 list-disc">{children}</li>;

const CONTENTS = {
  privacy: {
    title: "Informativa Privacy",
    updated: "Giugno 2026",
    body: (
      <>
        <P>Informativa resa ai sensi degli artt. 13-14 del Regolamento (UE) 2016/679 ("GDPR") per gli utenti del sito eneaspecialist.it e del servizio Home Exchange Copilot AI.</P>
        <H2>1. Titolare del trattamento</H2>
        <P>Vele Cinque S.r.l. (Gruppo Vela) — Email di contatto: velecinquesrl@gmail.com. Il Titolare può essere contattato per ogni richiesta relativa al trattamento dei dati personali.</P>
        <H2>2. Dati raccolti</H2>
        <ul>
          <LI>Dati identificativi e di contatto forniti volontariamente: nome e cognome del proprietario, email, telefono;</LI>
          <LI>Dati dell'immobile: indirizzo, tipologia, superfici, stato conservativo, anno, note;</LI>
          <LI>Documenti e foto caricati volontariamente (visure, planimetrie, immagini dell'immobile);</LI>
          <LI>Contenuto delle conversazioni con l'assistente virtuale e feedback della fase beta;</LI>
          <LI>Dati tecnici di funzionamento (log applicativi, indirizzo IP a fini di sicurezza e anti-abuso).</LI>
        </ul>
        <H2>3. Finalità e basi giuridiche</H2>
        <ul>
          <LI>Erogazione del servizio di valutazione immobiliare richiesta (esecuzione di misure precontrattuali, art. 6.1.b GDPR);</LI>
          <LI>Ricontatto da parte del team per l'analisi tecnica, promemoria e prenotazione call (art. 6.1.b e legittimo interesse, art. 6.1.f);</LI>
          <LI>Sicurezza del servizio e prevenzione di abusi/estrazione automatizzata dei dati (legittimo interesse, art. 6.1.f);</LI>
          <LI>Adempimenti di legge (art. 6.1.c GDPR).</LI>
        </ul>
        <H2>4. Modalità del trattamento e destinatari</H2>
        <P>I dati sono trattati con strumenti elettronici e misure di sicurezza adeguate. Possono venire a conoscenza dei dati: personale autorizzato di Gruppo Vela e fornitori tecnici nominati responsabili del trattamento (hosting, servizi email transazionali, servizi di analisi documentale automatizzata). I documenti e le foto caricati sono utilizzati esclusivamente per la valutazione richiesta.</P>
        <H2>5. Conservazione</H2>
        <P>I dati sono conservati per il tempo necessario a gestire la richiesta di valutazione e i successivi contatti e, in ogni caso, non oltre 24 mesi dall'ultimo contatto utile, salvo obblighi di legge o richieste di cancellazione.</P>
        <H2>6. Diritti dell'interessato</H2>
        <P>Ai sensi degli artt. 15-22 GDPR puoi chiedere in ogni momento: accesso, rettifica, cancellazione, limitazione, portabilità dei dati e opposizione al trattamento, scrivendo a velecinquesrl@gmail.com. Hai inoltre diritto di proporre reclamo al Garante per la Protezione dei Dati Personali (gpdp.it).</P>
      </>
    ),
  },
  cookie: {
    title: "Cookie Policy",
    updated: "Giugno 2026",
    body: (
      <>
        <P>Questo sito utilizza esclusivamente cookie e tecnologie di memorizzazione locale di natura <b>tecnica</b>, necessari al funzionamento del servizio. Non utilizziamo cookie di profilazione né strumenti di tracciamento pubblicitario di terze parti.</P>
        <H2>1. Memorizzazione tecnica utilizzata</H2>
        <ul>
          <LI><b>Salvataggio bozza</b> (localStorage): conserva sul tuo dispositivo i dati inseriti nel percorso di valutazione per permetterti di riprendere da dove eri rimasto. Durata: 7 giorni. Non lascia il tuo browser fino all'invio volontario della richiesta;</LI>
          <LI><b>Sessione area riservata</b> (localStorage): mantiene l'accesso del personale autorizzato al pannello amministrativo;</LI>
          <LI>Eventuali cookie tecnici dell'infrastruttura di hosting per bilanciamento e sicurezza.</LI>
        </ul>
        <H2>2. Gestione</H2>
        <P>Puoi cancellare in ogni momento i dati memorizzati localmente tramite le impostazioni del tuo browser (cancellazione dati di navigazione/localStorage). La disattivazione della memorizzazione tecnica può limitare alcune funzioni, come il recupero della bozza.</P>
        <H2>3. Terze parti</H2>
        <P>Il servizio di verifica indirizzi interroga provider cartografici (OpenStreetMap/Photon) in forma anonimizzata: nessun dato personale identificativo viene condiviso con tali provider oltre all'indirizzo dell'immobile oggetto di valutazione.</P>
      </>
    ),
  },
  termini: {
    title: "Termini e Condizioni d'Uso",
    updated: "Giugno 2026",
    body: (
      <>
        <P>L'accesso e l'utilizzo del sito eneaspecialist.it e del servizio Home Exchange Copilot AI (il "Servizio") comportano l'accettazione integrale dei presenti Termini. Se non li accetti, ti invitiamo a non utilizzare il Servizio.</P>
        <H2>1. Titolarità e proprietà intellettuale</H2>
        <P>Il Servizio, il sito, il marchio, i loghi, i testi, la grafica, l'interfaccia, il software, il metodo di valutazione, i flussi conversazionali, i report generati e ogni altro contenuto sono di titolarità esclusiva di <b>Vele Cinque S.r.l. (Gruppo Vela)</b> o dei rispettivi licenzianti, e sono protetti dalla normativa italiana ed europea su diritto d'autore, proprietà industriale e segreto commerciale (L. 633/1941, D.Lgs. 30/2005). <b>© Vele Cinque S.r.l. — Tutti i diritti riservati.</b></P>
        <H2>2. Divieto di copia, scraping ed estrazione dei dati</H2>
        <P>Salvo autorizzazione scritta del Titolare, è <b>espressamente vietato</b>:</P>
        <ul>
          <LI>copiare, riprodurre, distribuire, pubblicare o creare opere derivate del Servizio o di sue parti (incluse interfaccia, testi, flussi e report);</LI>
          <LI>effettuare <b>scraping, crawling, harvesting</b> o qualsiasi estrazione automatizzata o massiva di dati, valutazioni o contenuti, anche tramite bot, script o API non autorizzate;</LI>
          <LI>decompilare, disassemblare o effettuare <b>reverse engineering</b> del software o del metodo di valutazione;</LI>
          <LI>utilizzare il Servizio per sviluppare prodotti o servizi concorrenti o per addestrare sistemi automatizzati;</LI>
          <LI>aggirare le misure tecniche di protezione e i limiti di utilizzo del Servizio.</LI>
        </ul>
        <P>Le violazioni saranno perseguite nelle sedi civili e penali competenti, anche ai sensi degli artt. 98-99 D.Lgs. 30/2005 (segreti commerciali) e della normativa sul diritto d'autore e sulle banche dati (art. 102-bis L. 633/1941).</P>
        <H2>3. Natura delle valutazioni</H2>
        <P>Le valutazioni generate dal Servizio sono <b>stime indicative</b> basate sui dati inseriti dall'utente e su fonti pubbliche (quotazioni OMI dell'Agenzia delle Entrate) e non costituiscono perizia giurata, consulenza professionale né offerta contrattuale. Il valore definitivo richiede l'analisi di un tecnico incaricato.</P>
        <H2>4. Uso consentito</H2>
        <P>Il Servizio è destinato a un uso personale e non commerciale da parte di proprietari o interessati alla valutazione del proprio immobile. L'utente garantisce la veridicità dei dati inseriti e di avere titolo per caricare documenti e foto.</P>
        <H2>5. Limitazione di responsabilità</H2>
        <P>Nei limiti di legge, il Titolare non risponde di danni derivanti da uso improprio del Servizio, indisponibilità temporanea, o decisioni assunte dall'utente sulla base delle stime indicative.</P>
        <H2>6. Legge applicabile e foro</H2>
        <P>I presenti Termini sono regolati dalla legge italiana. Per ogni controversia è competente in via esclusiva il Foro del luogo in cui ha sede il Titolare, fatti salvi i fori inderogabili previsti per i consumatori.</P>
      </>
    ),
  },
};

export default function Legal({ type = "privacy" }) {
  const c = CONTENTS[type] || CONTENTS.privacy;
  return (
    <div className="min-h-screen bg-[#F0F9FC]" data-testid={`legal-page-${type}`}>
      <div className="bg-[#0b2545] text-white">
        <div className="max-w-3xl mx-auto px-6 py-10">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#A9D6E5] hover:text-white transition-colors" data-testid="legal-back-home">
            <ArrowLeft className="w-4 h-4" /> Torna al sito
          </Link>
          <div className="flex items-center gap-3 mt-6">
            <span className="w-10 h-10 rounded-xl bg-[#14B8A6] flex items-center justify-center"><ShieldCheck className="w-5 h-5 text-white" /></span>
            <div>
              <h1 className="text-2xl font-semibold" data-testid="legal-title">{c.title}</h1>
              <div className="text-xs text-[#A9D6E5] mt-0.5">Ultimo aggiornamento: {c.updated} · Vele Cinque S.r.l. (Gruppo Vela)</div>
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-6 py-10">
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-8">
          {c.body}
          <div className="mt-10 pt-4 border-t border-slate-100 flex flex-wrap gap-4 text-xs text-slate-500">
            <Link to="/privacy" className="hover:text-[#14B8A6]">Privacy</Link>
            <Link to="/cookie" className="hover:text-[#14B8A6]">Cookie</Link>
            <Link to="/termini" className="hover:text-[#14B8A6]">Termini d'uso</Link>
            <span className="ml-auto">© Vele Cinque S.r.l. — Tutti i diritti riservati</span>
          </div>
        </div>
      </div>
    </div>
  );
}
